import * as React from 'react';
import { ComponentLayout } from 'src/components/common/modules/component-layout/code-split/component-layout-component';
import { ComponentLayoutType } from 'src/components/common/modules/component-layout/component-layout';
import { V3HighlightThreeUpComponent } from './code-split/v3-highlight-three-up-component';
import { V3BrandHotelDealsModuleComponent } from '../v3-brand-hotel-deals-module/code-split/v3-brand-hotel-deals-module-component';

const V3HighlightThreeUp: React.FC<ComponentLayoutType<any>> = (props) => {
  const cardType = props?.data.cards?.[0]?._type;

  return (
    <ComponentLayout {...props}>
      {cardType === 'cardProduct' ? <V3BrandHotelDealsModuleComponent module = 'highlight_3_up'/> : <V3HighlightThreeUpComponent />}
    </ComponentLayout>
  );
};

export default V3HighlightThreeUp;
